import { render } from "./MultiselectCheckboxItem.vue?vue&type=template&id=19ddde36"
import script from "./MultiselectCheckboxItem.vue?vue&type=script&lang=js"
export * from "./MultiselectCheckboxItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__